const rolePermissionData = [
  {
    id: 1,
    label: 'Home Page',
    defaultName: 'home',
    labelItems: [
      // {
      //   id: 'notificationSection',
      //   name: 'Notification section',
      //   value: 'notificationSection',
      //   status: false
      // },
      {
        id: 'markNotificationResolved',
        name: 'Mark Resolved Notification',
        value: 'markNotificationResolved',
        status: false
      }
    ]
  },
  {
    id: 2,
    label: 'Trip page',
    defaultName: 'trip',
    labelItems: [
      {
        id: 'addTrip',
        name: 'Add Trip',
        value: 'addTrip',
        status: false
      },
      {
        id: 'editTrip',
        name: 'Edit Trip',
        value: 'editTrip',
        status: false
      },
      {
        id: 'deleteTrip',
        name: 'Delete Trip',
        value: 'deleteTrip',
        status: false
      },
      {
        id: 'unlockDevice',
        name: 'Unlock Device',
        value: 'unlockDevice',
        status: false
      },
      {
        id: 'editDriverDetail',
        name: 'Edit driver details',
        value: 'editDriverDetail',
        status: false
      },
      {
        id: 'tripStatus',
        name: 'Start/End trip',
        value: 'tripStatus',
        status: false
      },
      {
        id: 'geofence',
        name: 'Allow Geofence',
        value: 'geofence',
        status: false
      }
    ]
  },
  {
    id: 3,
    label: 'Device page',
    defaultName: 'device',
    labelItems: [
      // {
      //   id: 'addDevice',
      //   name: 'Add Device',
      //   value: 'addDevice',
      //   status: false
      // },
      // {
      //   id: 'bulkUplodDevice',
      //   name: 'Bulk Upload Device',
      //   value: 'bulkUplodDevice',
      //   status: false
      // },
      // {
      //   id: 'deleteDevice',
      //   name: 'Delete Device',
      //   value: 'deleteDevice',
      //   status: false
      // },
      {
        id: 'deviceSetting',
        name: 'Device Setting',
        value: 'deviceSetting',
        status: false
      },
      // {
      //   id: 'deviceAction',
      //   name: 'Device Action',
      //   value: 'deviceAction',
      //   status: false
      // },
      {
        id: 'exportDeviceData',
        name: 'Export Device Data',
        value: 'exportDeviceData',
        status: false
      }
    ]
  },

  {
    id: 5,
    label: 'Route page',
    defaultName: 'route',
    labelItems: [
      {
        id: 'addRoute',
        name: 'Add Route',
        value: 'addRoute',
        status: false
      },
      {
        id: 'editRouteDetail',
        name: 'Edit Route details',
        value: 'editRouteDetail',
        status: false
      },
      {
        id: 'deleteRoute',
        name: 'Delete Route',
        value: 'deleteRoute',
        status: false
      }
    ]
  },
  {
    id: 6,
    label: 'Vehicle page',
    defaultName: 'vehicle',
    labelItems: [
      {
        id: 'addVehicle',
        name: 'Add vehicle',
        value: 'addVehicle',
        status: false
      },
      {
        id: 'editVehicle',
        name: 'Edit vehicle details',
        value: 'editVehicle',
        status: false
      },
      {
        id: 'deleteVehicle',
        name: 'Delete vehicle',
        value: 'deleteVehicle',
        status: false
      }
    ]
  },
  {
    id: 7,
    label: 'Role Management',
    defaultName: 'roleManagement',
    labelItems: [
      {
        id: 'addRole',
        name: 'Create New Role',
        value: 'addRole',
        status: false
      },
      {
        id: 'editRole',
        name: 'Edit Role',
        value: 'editRole',
        status: false
      },
      {
        id: 'deleteRole',
        name: 'Delete Role',
        value: 'deleteRole',
        status: false
      }
    ]
  },
  {
    id: 8,
    label: 'User Management',
    defaultName: 'userManagement',
    labelItems: [
      {
        id: 'addUser',
        name: 'Create New User',
        value: 'addUser',
        status: false
      },
      {
        id: 'editUser',
        name: 'Edit User',
        value: 'editUser',
        status: false
      },
      {
        id: 'deleteUser',
        name: 'Delete User',
        value: 'deleteUser',
        status: false
      }
    ]
  },
  {
    id: 9,
    label: 'Control center page',
    defaultName: 'controlCenter',
    labelItems: [
      {
        id: 'controlCenterSetting',
        name: 'Control Center Setting',
        value: 'controlCenterSetting',
        status: false
      }
      // {
      //   id: 'profilePicture',
      //   name: 'Profile picture',
      //   value: 'profilePicture',
      //   status: false
      // }
    ]
  }
];

export default rolePermissionData;

export const permissionslabel = [
  {
    notificationSection: 'Notification Section',
    markNotificationResolved: 'Mark Resolved Notification',
    addTrip: 'Add Trip',
    editTrip: 'Edit trip',
    deleteTrip: 'Delete Trip',
    unlockDevice: 'Unlock Device',
    editDriverDetail: 'Edit driver details',
    tripStatus: 'Start/End trip',
    geofence: 'Allow Geofence',
    addDevice: 'Add Device',
    bulkUplodDevice: 'Bulk Upload Device',
    deleteDevice: 'Delete Device',
    deviceSetting: 'Device Setting',
    deviceAction: 'Device Action',
    exportDeviceData: 'Export Device Data',
    addRoute: 'Add Route',
    editRouteDetail: 'Edit Route details',
    deleteRoute: 'Delete Route',
    addVehicle: 'Add vehicle',
    editVehicle: 'Edit vehicle details',
    deleteVehicle: 'Delete vehicle',
    addRole: 'Create New Role',
    editRole: 'Edit Role',
    deleteRole: 'Delete Role',
    addUser: 'Create New User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    controlCenterSetting: 'Control Center Setting',
    profilePicture: 'Profile picture'
  }
];
